import * as React from "react";
import { InjectRouteParams } from "../../Common/Routing/InjectRouteParams";
import { PermissionRoute } from "../../Common/Routing/PermissionRoute";

const Customers = React.lazy(() => import("./Customers"));
const CustomerCreate = React.lazy(() => import("./CustomerCreate"));
const CustomerEdit = React.lazy(() => import("./CustomerEdit"));
const CustomerView = React.lazy(() => import("./CustomerView"));
const CustomersMerge = React.lazy(() => import("./CustomersMerge"));
const CustomerPaymentRoute = React.lazy(() => import("./CustomerPaymentRoute"));

export default function CustomerIndex(): Array<React.ReactNode> {
    return [
        <PermissionRoute
            permissions={[ "see_customers" ]}
            title="Customers | Shopfront"
            path="/customers"
            key="customers"
            element={<Customers />}
        />,
        <PermissionRoute
            permissions={[ "see_customers", "edit_customers" ]}
            title="Merge Customers | Shopfront"
            path="/customers/merge"
            key="customers-merge"
            element={<CustomersMerge />}
        />,
        <PermissionRoute
            permissions={[ "create_customers" ]}
            title="Create Customer | Shopfront"
            path="/customer/new"
            key="customer-create"
            element={<CustomerCreate />}
        />,
        <PermissionRoute
            permissions={[ "make_customer_payments" ]}
            title="Account Payment | Shopfront"
            path="/customer/payment"
            key="customer-payment"
            element={<CustomerPaymentRoute />}
        />,
        <PermissionRoute
            permissions={[ "make_customer_payments" ]}
            title="Account Payment | Shopfront"
            path="/customer/payment/:id"
            key="customer-payment-with-id"
            element={<CustomerPaymentRoute />}
        />,
        <PermissionRoute
            permissions={[ "see_customers" ]}
            title="View Customer | Shopfront"
            path="/customer/:id"
            key="customer-view"
            element={<CustomerView />}
        />,
        <PermissionRoute
            permissions={[ "edit_customers" ]}
            title="Edit Customer | Shopfront"
            path="/customer/:id/edit"
            key="customer-edit"
            element={<InjectRouteParams route={CustomerEdit} />}
        />,
    ];
}
